
//-------------------------------------------------------------------------
// FORMATO ITENS: 
// MaterialID | QtOrder | Quantitities[0, 0, 0, 0] | QtMissing
//-------------------------------------------------------------------------
function SdOrderEventsCtrl(TranslationService, ToastService, StoreService) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();

    ctrl.changeSent = function (event) {
        //console.log('changeSent ' + event.SentNotification);
        event.SentNotification = !event.SentNotification;
        var toastID = ToastService.createToast('Salvando ...', '', 2000, 'wait');        
        StoreService.saveSentNotification(event).then(
            function (result) {
                //event.sentNotification = result.data;                
                //console.log('salvo');
                ToastService.updateToast(toastID, 'Salvo', '', 1000, 'success');
            },
            function (error) {
                //var errorMsg = error.data.Message;
                //var errorExc = error.data.ExceptionMessage;                    
                ToastService.updateToast(toastID, 'Erro ao salvar!', '', 2000, 'error');
            }
        );
    };

}

SdOrderEventsCtrl.$inject = ['TranslationService', 'ToastService', 'StoreService'];

seedWebApp.component('sdOrderEvents', {
    controller: SdOrderEventsCtrl,
    bindings: {
        loading: '<',
        order: '<',
        orderEvents: '<',
    },
    templateUrl: '/SPA/Orders/sd-order-events.html' + seedWebApp.buildVersion
});